import { type MetaFunction } from '@remix-run/node';
import { Link } from '@remix-run/react';
import { differenceInCalendarDays } from 'date-fns';
import { Button } from '#app/components/ui/button.tsx';
import Hotel from './burley-manor.jpg';
import Us from './image.png';

export const meta: MetaFunction = () => [{ title: 'Charlotte & Alex Wedding' }];

const VenueInfo = ({
  name,
  address,
  time
}: {
  name: string;
  address: string;
  time: string;
}) => (
  <div className="text-lg space-y-3">
    <p className="font-medium">{name}</p>
    <p>{address}</p>
    <p className="font-semibold">{time}</p>
  </div>
);

export default function Index() {
  const daysToGo = differenceInCalendarDays(new Date(2026, 7, 14, 0), new Date());

  return (
    <div className="flex flex-col bg-bg-main text-neutral-600">
      <div className="relative w-full">
        <img
          src={Us}
          alt="Charlotte and Alex"
          className="object-cover w-full brightness-50"
        />
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <div className="text-center space-y-6">
            <h1 className="text-5xl font-bold font-dancing-script text-white drop-shadow-[0_2px_2px_rgba(0,0,0,0.8)]">
              Charlotte & Alex
            </h1>
            <p className="text-2xl text-white drop-shadow-[0_2px_2px_rgba(0,0,0,0.8)]">
              Friday, 14th August 2026
            </p>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-center flex-col text-center pt-14 px-6">
        <h2 className="mb-8 text-4xl font-bold font-dancing-script text-secondary">
          The Ceremony
        </h2>
        <VenueInfo
          name="St John the Baptist Church"
          address="Church Lane, Burley, Ringwood BH24 4AP"
          time="3pm"
        />
      </div>

      <div className="px-8 py-6">
        <hr className="border-0 h-1 bg-accent shadow-lg rounded-full" />
      </div>

      <div className="flex flex-col md:flex-row items-center gap-12 justify-center px-6 py-14">
        <div className="flex items-center justify-center flex-col text-center">
          <h2 className="mb-8 text-4xl font-bold font-dancing-script text-secondary">
            The Reception
          </h2>
          <VenueInfo
            name="Burley Manor"
            address="1 Ringwood Road, Burley, Ringwood BH24 4BS"
            time="5pm"
          />
        </div>

        <div className="w-full md:w-1/2 h-[300px]">
          <img
            src={Hotel}
            alt="Burley Manor"
            className="object-cover w-full h-full"
          />
        </div>
      </div>

      <div className="px-8 py-6">
        <hr className="border-0 h-1 bg-accent shadow-lg rounded-full" />
      </div>

      <div className="flex flex-col items-center py-14">
        <h2 className="mb-8 text-4xl font-bold font-dancing-script text-secondary">RSVP</h2>
        <Button
          asChild
          variant="default"
          size="lg"
          className="bg-secondary text-white hover:bg-secondary/90"
        >
          <Link to="/rsvp">
            Click to RSVP
          </Link>
        </Button>
      </div>

      <section className="flex flex-col items-center justify-center p-8 bg-accent/5 rounded-t-3xl">
        <div className="text-center space-y-2">
          <p className="text-2xl font-bold text-accent">
            {daysToGo} {daysToGo === 1 ? 'Day' : 'Days'} to go!
          </p>
        </div>
      </section>
    </div>
  );
}
